import { render, staticRenderFns } from "./AvChartBar.vue?vue&type=template&id=63a0fe00&scoped=true"
import script from "./AvChartBar.vue?vue&type=script&lang=ts"
export * from "./AvChartBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a0fe00",
  null
  
)

export default component.exports